import { setUsrAppRefreshParams } from '@jfs/network'
import { IconOptions } from '@jfs/ui-new'
import { useEffect } from 'react'
import { FlatList } from 'react-native'
import { Container } from '../../comps/Container'
import { useStores } from '../../data/store'
import { Screens } from '../../nav/Screens'
import { AppHeaderTransformer, extendAppSession } from '../../network/ExtendAppSession'
import { HeaderTransformer, extendUserSession } from '../../network/ExtendUserSession'
import { HomeScreenItem } from './HomeScreenItem'

export const HomeScreen = () => {
  const {
    userAccessToken,
    userRefreshToken,
    appAccessToken,
    appRefreshToken,
    clientId,
    CHANNEL_ID,
    mobileNO,
    showErrDialog,
  } = useStores((root) => ({
    userAccessToken: root.agent.session.userAccessToken,
    userRefreshToken: root.agent.session.userRefreshToken,
    appAccessToken: root.agent.session.appAccessToken,
    appRefreshToken: root.agent.session.appRefreshToken,
    clientId: root.agent.CLIENT_ID,
    CHANNEL_ID: root.agent.session.CHANNEL_ID,
    mobileNO: root.agent.agentInfo.agentUserLoginId,
    showErrDialog: root.message.showErrDialog,
  }))

  useEffect(() => {
    setUsrAppRefreshParams(
      extendUserSession(userAccessToken, userRefreshToken, CHANNEL_ID, mobileNO),
      HeaderTransformer,
      extendAppSession(appAccessToken, appRefreshToken, clientId, CHANNEL_ID),
      AppHeaderTransformer,
    )
  }, [userAccessToken, userRefreshToken, appAccessToken, appRefreshToken, CHANNEL_ID, clientId, mobileNO])

  const onAadhaarCardLinked = () => {
    showErrDialog('Aadhaar card linked with your account sucessfully.', 'POSITIVE')
  }

  return (
    <Container showFooter={true}>
      <FlatList
        data={DATA}
        renderItem={({ item }) => <HomeScreenItem data={item} onAadhaarCardLinked={onAadhaarCardLinked} />}
      />
    </Container>
  )
}

const DATA = [
  {
    screenName: 'Cash Withdrawal',
    icon: 'CASH_WITHDRAWL',
    navigate: Screens.CASH_W_OR_D_Screen,
    params: { type: 'cash_withdrawal' },
  },
  {
    screenName: 'Cash Deposit',
    icon: 'CASH_DEPOSIT',
    navigate: Screens.CASH_W_OR_D_Screen,
    params: { type: 'cash_deposit' },
  },
  {
    screenName: 'Fund Transfer',
    icon: 'FUND_TRANSFER',
    navigate: Screens.FUND_TRANSFER,
  },
  {
    screenName: 'Balance Enquiry',
    icon: 'BALANCE_ENQUIRY',
    navigate: Screens.BALANCE_ENQUIRY,
  },

  {
    screenName: 'Mini Statement',
    icon: 'MINI_STATEMENT',
    navigate: Screens.MINI_STATEMENT,
  },
  {
    screenName: 'Transaction Enquiry',
    icon: 'TNX_ENQUIRY',
    navigate: Screens.TRANSACTION_ENQUIRY,
  },
  {
    screenName: 'Link Aadhar',
    icon: 'PAYMENT_LINKS' as IconOptions,
    navigate: Screens.ENTER_CUSTOMER_MOBILE,
    params: {},
  },
  {
    screenName: 'Scan QR',
    icon: 'TNX_ENQUIRY',
    navigate: Screens.SCAN_QR,
  },
]
